import { render, staticRenderFns } from "./ImagePlaceholder.vue?vue&type=template&id=01105ae1&scoped=true"
import script from "./ImagePlaceholder.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImagePlaceholder.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ImagePlaceholder.vue?vue&type=style&index=0&id=01105ae1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01105ae1",
  null
  
)

export default component.exports